import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useIsMobile = (mobileSize = 1030) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < mobileSize);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < mobileSize);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileSize]);

  return isMobile;
};

export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
};

export const useLoading = (accessToken, releases, mixData) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkDataLoading = () => {
      if (accessToken && releases && mixData) {
        setLoading(false);
      } else {
        setLoading(true);
      }
    };

    checkDataLoading();
  }, [accessToken, releases, mixData]);
  return loading;
};
